function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingPlans1 = function SvgLandingPlans1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18202_16787)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 24,
    fill: "#610095"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5625 40.4992C37.311 39.8339 38.439 39.8339 39.1875 40.4992C39.6961 40.9513 40.5 40.5902 40.5 39.9098V20.0884C40.5 19.408 39.6961 19.047 39.1875 19.499C38.439 20.1644 37.311 20.1644 36.5625 19.499C35.814 18.8337 34.686 18.8337 33.9375 19.499C33.189 20.1644 32.061 20.1644 31.3125 19.499C30.564 18.8337 29.436 18.8337 28.6875 19.499C27.939 20.1644 26.811 20.1644 26.0625 19.499C25.314 18.8337 24.186 18.8337 23.4375 19.499C22.689 20.1644 21.561 20.1644 20.8125 19.499C20.3039 19.047 19.5 19.408 19.5 20.0884V39.9098C19.5 40.5902 20.3039 40.9513 20.8125 40.4992C21.561 39.8339 22.689 39.8339 23.4375 40.4992C24.186 41.1646 25.314 41.1646 26.0625 40.4992C26.811 39.8339 27.939 39.8339 28.6875 40.4992C29.436 41.1646 30.564 41.1646 31.3125 40.4992C32.061 39.8339 33.189 39.8339 33.9375 40.4992C34.686 41.1646 35.814 41.1646 36.5625 40.4992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 34.0859H35.25",
    stroke: "#610095",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 30H35.25",
    stroke: "#610095",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.75 25.9141H35.25",
    stroke: "#610095",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter0_dii_18202_16787)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.289062,
    width: 62.7024,
    height: 62.0133,
    rx: 24,
    transform: "rotate(-0.27563 0 0.289062)",
    fill: "url(#paint0_linear_18202_16787)",
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_18202_16787",
    x: -4.42874,
    y: -3.7916,
    width: 78.9949,
    height: 76.3609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.54202,
    dy: 3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18202_16787"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_18202_16787",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.54202,
    dy: 3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_18202_16787"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4.54202,
    dy: -3.2443
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.56873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_18202_16787",
    result: "effect3_innerShadow_18202_16787"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18202_16787",
    x1: 10.8965,
    y1: 7.85166,
    x2: 52.6412,
    y2: 53.4981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18202_16787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 24,
    fill: "white"
  }))));
};
export default SvgLandingPlans1;